import Errors                                       from "../../../domain/fundamentals/message/error/Errors";
import { ACTION_TYPE, ErrorAction, ErrorSetAction } from "./ErrorAction";

const errorReducer = (state: Errors = new Errors(), action: ErrorAction): Errors => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.ERROR_INIT:
      return new Errors();
    case ACTION_TYPE.ERROR_SET:
      return errorSetReduce(action as ErrorSetAction);
  }
};

const errorSetReduce = (action: ErrorSetAction): Errors => {
  return action.errors;
};

export default errorReducer;